import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useGetAllCategoryQuery } from 'App/services/categoryServiceApi';
import { useUpdateSubCategoryMutation } from 'App/services/subCategoryServiceApi';
import { Icon, IconButton } from '@mui/material';
import { toast } from 'react-toastify';

export default function EditSubCategoryFormDialogue({ subcategory }) {

  const [open, setOpen] = React.useState(false);
  const [subcategoryName, setSubcategoryName] = React.useState(subcategory.name);
  const [categoryId, setCategoryId] = React.useState(subcategory.cat_id);
  const [error, setError] = React.useState('')
  const navigate = useNavigate();

  const { data: subcategories, error: subcategoriesError, isLoading: subcategoriesLoading } = useGetAllCategoryQuery();
  const [updateSubCategory, { isLoading, isError }] = useUpdateSubCategoryMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditSubCategory = async (event) => {
    event.preventDefault();

    
    if (subcategoryName) {
      try {
        await updateSubCategory({ id: subcategory.id, name: subcategoryName, categoryId });
        toast.success("Sub Category Successfully updated!")
        handleClose();
      } catch (err) {
        console.error('Failed to update subcategory: ', err);
        toast.error("Something went wrong!!")
      }
    }
    else {
      toast.error("Required to subCategory Field name")
    }
  };

  return (
    <React.Fragment>
      <IconButton onClick={handleClickOpen}>
        <Icon>edit</Icon>
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleEditSubCategory,
        }}
      >
        <DialogTitle>Edit Sub Category</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Update the name and category of the subcategory:
          </DialogContentText>
          <TextField
            autoFocus
            // required
            margin="dense"
            id="name"
            name="name"
            label="Sub Category Name"
            type="text"
            fullWidth
            value={subcategoryName}
            onChange={(e) => setSubcategoryName(e.target.value) }
            error={!!error}
            helperText={error}
          />
          <Select
            required
            fullWidth
            disabled
            sx={{ height: 40 }}
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
            displayEmpty
          >

            <p style={{ color: "red" }}>{error}</p>
            <MenuItem value="" disabled>Select Category</MenuItem>
            {subcategoriesLoading ? (
              <MenuItem disabled>Loading...</MenuItem>
            ) : subcategoriesError ? (
              <MenuItem disabled>Error loading categories</MenuItem>
            ) : (
              subcategories.map((subcategory) => (
                <MenuItem key={subcategory.id} value={subcategory.id}>
                  {subcategory.name}
                </MenuItem>
              ))
            )}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading} name="submit">
            Update {isLoading && 'Loading...'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
